module.exports = __webpack_public_path__ + "img/scheme_lg.391c871.webp";